export const log = (msg?: any, ...optionalParams: any[]) => {
  /**
   * Use this at places where we really want a console log,
   * so that when we search the codebase for console.log(),
   * we don't get too many hits.
   */
  console.log(msg, ...optionalParams)
}
